export default __webpack_public_path__ + "static/media/redCross.bf28cfb5.svg";